var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"change-column-count",on:{"click":function($event){return _vm.setCount()}}},[_vm._v(" "+_vm._s(_vm.countVariants[_vm.countIndex])+" days ")])}
var staticRenderFns = []

export { render, staticRenderFns }